var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var PC;
    (function (PC) {
        var SpotComponent;
        (function (SpotComponent) {
            var DetailExternalRateView = (function (_super) {
                __extends(DetailExternalRateView, _super);
                function DetailExternalRateView(params) {
                    var _this = _super.call(this, { delegate: false }) || this;
                    _this.currentLabel = { name: 'aggregated', display_text: '総合' };
                    _this.labelListIndex = 0;
                    _this.spotId = params.spotId;
                    _this.addEventListner(_this.spotId);
                    _this.labels = $(".js-detail-external-rate-labels-" + _this.spotId).data('labels') || [];
                    return _this;
                }
                DetailExternalRateView.prototype.addEventListner = function (spotId) {
                    var _this = this;
                    $("#js-external-rate-info-mark-" + spotId).mouseenter(function () {
                        $("#js-external-rate-popup-" + spotId).css('display', 'flex');
                    }).mouseleave(function () {
                        $("#js-external-rate-popup-" + spotId).css('display', 'none');
                    });
                    $(".js-detail-external-rate-arrow-right-" + spotId).click(function () {
                        _this.beforeArrowButtonClick(_this.currentLabel);
                        _this.labelListIndex = (_this.labels.length + _this.labelListIndex + 1) % _this.labels.length;
                        _this.currentLabel = _this.labels[_this.labelListIndex];
                        _this.afterArrowButtonClick(_this.currentLabel);
                    });
                    $(".js-detail-external-rate-arrow-left-" + spotId).click(function () {
                        _this.beforeArrowButtonClick(_this.currentLabel);
                        _this.labelListIndex = (_this.labels.length + _this.labelListIndex - 1) % _this.labels.length;
                        _this.currentLabel = _this.labels[_this.labelListIndex];
                        _this.afterArrowButtonClick(_this.currentLabel);
                    });
                };
                DetailExternalRateView.prototype.beforeArrowButtonClick = function (currentLabel) {
                    $(".js-external-rate-popup-wrapper-" + this.spotId + "-" + currentLabel.name).css('display', 'none');
                };
                DetailExternalRateView.prototype.afterArrowButtonClick = function (currentLabel) {
                    $(".js-external-rate-popup-wrapper-" + this.spotId + "-" + currentLabel.name).css('display', 'flex');
                };
                return DetailExternalRateView;
            }(Fily.BaseView));
            SpotComponent.DetailExternalRateView = DetailExternalRateView;
        })(SpotComponent = PC.SpotComponent || (PC.SpotComponent = {}));
    })(PC = Fily.PC || (Fily.PC = {}));
})(Fily || (Fily = {}));
